@if (active) {
  <div class="intro-splash" [class.is-leaving]="leaving" [class.is-flying]="flying" (click)="skip()">
    <div #backdrop class="intro-splash__backdrop"></div>
    <canvas
      #canvas
      class="intro-splash__canvas"
      role="img"
      aria-label="The gold WorldTumbler D20 emblem rolls right to left and settles beside the WorldTumbler name"
    ></canvas>
    <button type="button" class="intro-splash__skip" (click)="skip(); $event.stopPropagation()">Skip</button>
  </div>
}
